// Constants
export const permissionsList = [
  {
    label: 'rolesManagement',
    children: [
      { value: 'rolesView', label: 'rolesView' },
      { value: 'rolesManage', label: 'rolesManage' },
    ],
  },
  {
    label: 'usersManagement',
    children: [
      { value: 'usersView', label: 'usersView' },
      { value: 'usersManage', label: 'usersManage' },
    ],
  },
  {
    label: 'operations',
    children: [
      { value: 'operationsView', label: 'operationsView' },
      { value: 'operationsManage', label: 'operationsManage' },
    ],
  },
  {
    label: 'receivedSamples',
    children: [
      { value: 'receivedSamplesView', label: 'receivedSamplesView' },
      { value: 'receivedSamplesDownload', label: 'receivedSamplesDownload' },
      { value: 'receivedSamplesManage', label: 'receivedSamplesManage' },
    ],
  },
  {
    label: 'workPlanning',
    children: [{ value: 'workPlanningManage', label: 'workPlanningManage' }],
  },
  {
    label: 'quarantine',
    children: [
      { value: 'quarantineView', label: 'quarantineView' },
      { value: 'quarantineManage', label: 'quarantineManage' },
    ],
  },
  {
    label: 'thermostats',
    children: [
      { value: 'thermostatsView', label: 'thermostatsView' },
      { value: 'thermostatsManage', label: 'thermostatsManage' },
    ],
  },
  {
    label: 'analysisDataTemperature',
    children: [
      {
        value: 'analysisDataTemperatureView',
        label: 'analysisDataTemperatureView',
      },
      {
        value: 'analysisDataTemperatureManage',
        label: 'analysisDataTemperatureManage',
      },
    ],
  },
  {
    label: 'terrainDiluentLot',
    children: [
      { value: 'terrainDiluentLotView', label: 'terrainDiluentLotView' },
      { value: 'terrainDiluentLotManage', label: 'terrainDiluentLotManage' },
    ],
  },
  {
    label: 'analysesData',
    children: [
      { value: 'analysesDataView', label: 'analysesDataView' },
      { value: 'analysesDataManage', label: 'analysesDataManage' },
    ],
  },
  {
    label: 'analysisImportMapping',
    children: [
      {
        value: 'analysisImportMappingView',
        label: 'analysisImportMappingView',
      },
      {
        value: 'analysisImportMappingManage',
        label: 'analysisImportMappingManage',
      },
    ],
  },
  {
    label: 'analysesStatus',
    children: [
      { value: 'analysesStatusView', label: 'analysesStatusView' },
      { value: 'analysesStatusManage', label: 'analysesStatusManage' },
    ],
  },
  {
    label: 'printReport',
    children: [{ value: 'printReportManage', label: 'printReportManage' }],
  },
  {
    label: 'printAnalyses',
    children: [{ value: 'printAnalysesManage', label: 'printAnalysesManage' }],
  },
  {
    label: 'search',
    children: [{ value: 'searchManage', label: 'searchManage' }],
  },
  {
    label: 'thermostatSearch',
    children: [
      { value: 'thermostatSearchManage', label: 'thermostatSearchManage' },
    ],
  },
  {
    label: 'symbolSearch',
    children: [{ value: 'symbolSearchManage', label: 'symbolSearchManage' }],
  },
  {
    label: 'changelog',
    children: [{ value: 'changelogView', label: 'changelogView' }],
  },
  {
    label: 'signature',
    children: [
      { value: 'signatureUser', label: 'signatureUser' },
      { value: 'signatureManage', label: 'signatureManage' },
      { value: 'accrediaSignature', label: 'accrediaSignature' },
    ],
  },
  {
    label: 'systemAdministration',
    children: [
      { value: 'systemAdministration', label: 'systemAdministration' },
    ],
  },
  {
    label: 'locationsManagement',
    children: [
      { value: 'locationsView', label: 'locationsView' },
      { value: 'locationsManage', label: 'locationsManage' },
    ],
  },
  {
    label: 'analysisLocations',
    children: [
      { value: 'analysisLocationView', label: 'analysisLocationView' },
      { value: 'analysisLocationsManage', label: 'analysisLocationsManage' },
    ],
  },
  {
    label: 'locationSectorDepartment',
    children: [
      {
        value: 'locationSectorDepartmentView',
        label: 'locationSectorDepartmentView',
      },
      {
        value: 'locationSectorDepartmentManage',
        label: 'locationSectorDepartmentManage',
      },
    ],
  },
  {
    label: 'sampleAnalysisLocation',
    children: [
      {
        value: 'sampleAnalysisLocationView',
        label: 'sampleAnalysisLocationView',
      },
      {
        value: 'sampleAnalysisLocationManage',
        label: 'sampleAnalysisLocationManage',
      },
    ],
  },
  {
    label: 'locationCustomer',
    children: [
      {
        value: 'locationCustomerDepartmentView',
        label: 'locationCustomerDepartmentView',
      },
      {
        value: 'locationCustomerDepartmentManage',
        label: 'locationCustomerDepartmentManage',
      },
    ],
  },
  {
    label: 'familyType',
    children: [
      { value: 'familyTypeView', label: 'familyTypeView' },
      { value: 'familyTypeManage', label: 'familyTypeManage' },
    ],
  },
  {
    label: 'stabilityConfig',
    children: [
      { value: 'stabilityConfigView', label: 'stabilityConfigView' },
      { value: 'stabilityConfigManage', label: 'stabilityConfigManage' },
    ],
  },
  {
    label: 'stabilityTimePointExport',
    children: [
      {
        value: 'stabilityTimePointExport',
        label: 'stabilityTimePointExport',
      },
    ],
  },
  {
    label: 'advancedTools',
    children: [
      { value: 'advancedRevision', label: 'advancedRevision' },
      { value: 'advancedRevisionView', label: 'advancedRevisionView' },
    ],
  },
  {
    label: 'monitoringDashboard',
    children: [
      { value: 'dashboardMonitoringView', label: 'dashboardMonitoringView' },
      {
        value: 'dashboardMonitoringAcceptanceView',
        label: 'dashboardMonitoringAcceptanceView',
      },
      {
        value: 'dashboardMonitoringNoteManage',
        label: 'dashboardMonitoringNoteManage',
      },
    ],
  },
];

export const sectorsList = [
  { value: 'other' },
  { value: 'chemical' },
  { value: 'cosmetic' },
  { value: 'detergents' },
  { value: 'medicalDevice' },
  { value: 'pharmaceutical' },
  { value: 'foodSupplement' },
  { value: 'packaging' },
  { value: 'biocide' },
  { value: 'nonSterile' },
  { value: 'animalWellness' },
  { value: 'environmental' },
  { value: 'OTC' },
  { value: 'microbiologicalMedium' },
];

export const sampleDescriptionsList = [
  { value: 'anhydrousFluid' },
  { value: 'anhydrousPaste' },
  { value: 'sanitaryTowelsDiapers' },
  { value: 'biphasic' },
  { value: 'capsule' },
  { value: 'tablet' },
  { value: 'emulsion' },
  // retired from the business vocabulary; kept readable on historical samples
  { value: 'liquidGel', deprecated: true },
  { value: 'liquid' },
  { value: 'oil' },
  { value: 'packaging' },
  { value: 'patch' },
  { value: 'pressedPowder' },
  { value: 'loosePowder' },
  { value: 'wipes' },
  { value: 'validation' },
  { value: 'agarPlate' },
  { value: 'swab' },
  { value: 'sponge' },
  { value: 'granulate' },
  { value: 'water' },
  { value: 'materialBasedMedicalDevice' },
  { value: 'gel' },
  { value: 'oilyLiquid' },
  { value: 'solid' },
  { value: 'propellantSpray' },
  { value: 'stick' },
  { value: 'fabric' },
];

export const laboratories = {
  // DEFAULT: 'DEFAULT',
  CHIM: 'CHIM',
  MICR: 'MICR',
};

export const documentTypes = {
  TestReport: 'TestReport',
};

export const LAB_SAMPLE_STATUSES = {
  PENDING: 0,
  ACCEPTED: 1,
  INPROGRESS: 2,
  SUSPENDED: 3,
  TOBEVERIFIED: 4,
  CANCELED: 5,
  REJECTED: 6,
  COMPLETED: 7,
  TOBEAPPROVED: 8,
};

export const LAB_SAMPLE_STATUSES_DESC = {
  [LAB_SAMPLE_STATUSES.PENDING]: 'pending',
  [LAB_SAMPLE_STATUSES.ACCEPTED]: 'accepted',
  [LAB_SAMPLE_STATUSES.INPROGRESS]: 'inprogress',
  [LAB_SAMPLE_STATUSES.SUSPENDED]: 'suspended',
  [LAB_SAMPLE_STATUSES.TOBEVERIFIED]: 'toBeVerified',
  [LAB_SAMPLE_STATUSES.CANCELED]: 'canceled',
  [LAB_SAMPLE_STATUSES.REJECTED]: 'rejected',
  [LAB_SAMPLE_STATUSES.COMPLETED]: 'completed',
  [LAB_SAMPLE_STATUSES.TOBEAPPROVED]: 'toBeApproved',
};

export const SAMPLE_REPORT_STATUSES = {
  DRAFT: 'draft',
  INPROGRESS: 'inProgress',
  DOCUMENTPENDING: 'documentPending',
  TOBEAPPROVED: 'toBeApproved',
  APPROVED: 'approved',
};

export const ORDER_LOCK_TYPE = {
  /** Order has no locks */
  NONE: 0,
  /** Order can only be accepted, cannot be modified further. Only sample labels can be printed */
  ACCEPTANCE: 1,
  /** Order can proceed normally until the test report generation, which is locked */
  REPORT: 2,
  /** Both acceptance and report */
  ACCEPTANCE_REPORT: 3,
};

/** @deprecated: Use new LabSamples statuses */
export const SAMPLE_STATUSES = {
  CREATED: 0,
  PENDING: 1,
  ACCEPTED: 2,
  INPROGRESS: 3,
  DRAFT: 4,
  CONCLUDED: 5,
  CANCELED: 6,
  REJECTED: 7,
  SUSPENDED: 8,
  TOBEVERIFIED: 9,
  TOBEAPPROVED: 10,
};

/** @deprecated: Use new LabSamples statuses */
export const SAMPLE_STATUSES_DESC = {
  [SAMPLE_STATUSES.CREATED]: 'created',
  [SAMPLE_STATUSES.PENDING]: 'pending',
  [SAMPLE_STATUSES.ACCEPTED]: 'accepted',
  [SAMPLE_STATUSES.INPROGRESS]: 'inprogress',
  [SAMPLE_STATUSES.DRAFT]: 'draft',
  [SAMPLE_STATUSES.CONCLUDED]: 'concluded',
  [SAMPLE_STATUSES.CANCELED]: 'canceled',
  [SAMPLE_STATUSES.REJECTED]: 'rejected',
  [SAMPLE_STATUSES.SUSPENDED]: 'suspended',
  [SAMPLE_STATUSES.TOBEVERIFIED]: 'toBeVerified',
  [SAMPLE_STATUSES.TOBEAPPROVED]: 'toBeApproved',
};

export const SAMPLE_ACTIONS = {
  ACCEPT: 0,
  REJECT: 1,
  SUSPEND: 2,
  REACTIVATE: 3,
  CANCEL: 4,
  ASKAPPROVAL: 5,
  DRAFT: 6,
  COMPLETE: 7,
  REMOVEDRAFT: 8,
};

export const SAMPLE_ACTIONS_DESC = {
  [SAMPLE_ACTIONS.ACCEPT]: 'accept',
  [SAMPLE_ACTIONS.REJECT]: 'reject',
  [SAMPLE_ACTIONS.SUSPEND]: 'suspend',
  [SAMPLE_ACTIONS.REACTIVATE]: 'reactivate',
  [SAMPLE_ACTIONS.CANCEL]: 'cancel',
  [SAMPLE_ACTIONS.ASKAPPROVAL]: 'askApproval',
  [SAMPLE_ACTIONS.DRAFT]: 'draft',
  [SAMPLE_ACTIONS.COMPLETE]: 'complete',
  [SAMPLE_ACTIONS.REMOVEDRAFT]: 'removeDraft',
};

export const ANALYSIS_ACTIONS = {
  CANCEL: 4,
};

export const ANALYSIS_ACTIONS_DESC = {
  [ANALYSIS_ACTIONS.CANCEL]: 'cancel',
};

export const QUARANTINE_REASONS = {
  UNIDENTIFIED: 0,
  NONCOMPLIANT: 1,
};

export const QUARANTINE_REASONS_DESC = {
  [QUARANTINE_REASONS.UNIDENTIFIED]: 'unidentified',
  [QUARANTINE_REASONS.NONCOMPLIANT]: 'nonCompliant',
};

export const SAMPLE_ANALYSIS_STATUSES = {
  PENDING: 0,
  ACCEPTED: 1,
  INPROGRESS: 2,
  COMPLETED: 3,
  CANCELED: 4,
  SUSPENDED: 5,
  REJECTED: 6,
};

export const SAMPLE_ANALYSIS_STATUSES_DESC = {
  [SAMPLE_ANALYSIS_STATUSES.PENDING]: 'pending',
  [SAMPLE_ANALYSIS_STATUSES.ACCEPTED]: 'accepted',
  [SAMPLE_ANALYSIS_STATUSES.INPROGRESS]: 'inprogress',
  [SAMPLE_ANALYSIS_STATUSES.COMPLETED]: 'completed',
  [SAMPLE_ANALYSIS_STATUSES.CANCELED]: 'canceled',
  [SAMPLE_ANALYSIS_STATUSES.SUSPENDED]: 'suspended',
  [SAMPLE_ANALYSIS_STATUSES.REJECTED]: 'rejected',
};

export const ANALYSES_COMMODITY_CATEGORIES = {
  MICROBIOLOGICAL: 'MICR',
  CHEMICAL: 'CHEM',
};

export const ANALYSES_COMMODITY_CATEGORIES_DESC = {
  [ANALYSES_COMMODITY_CATEGORIES.MICROBIOLOGICAL]: 'MICROBIOLOGICAL',
  [ANALYSES_COMMODITY_CATEGORIES.CHEMICAL]: 'CHEMICAL',
};

export const insertAnalysesDataBulkActions = {
  enableRawData: 'EnableRawData',
  disableRawData: 'DisableRawData',
  insertExpectedValues: 'InsertExpectedValues',
  bulkAskApproval: 'BulkAskApproval',
};

export const analysesStatusManageBulkActions = {
  changeSamplesStatus: 'changeSamplesStatus',
  enableRawData: 'enableRawData',
  disableRawData: 'disableRawData',
};

export const DILUTIONS = {
  None: ' ',
  OneTo10: '1:10',
  OneTo100: '1:100',
  OneTo1: 'TQ',
  OneTo8: '1:1:8',
  OneTo98: '1:1:98',
};

export const ANALYSIS_CLASS_TYPE_VALUES = {
  Fixed: 0,
  Single: 9999,
};

export const ANALYSIS_CLASS_TYPES = {
  Fixed: 'fixed',
  Dynamic: 'dynamic',
  Single: 'single',
};

export const getAnalysisClassType = (classType) => {
  if (classType === null || classType === undefined) return null;
  if (classType === ANALYSIS_CLASS_TYPE_VALUES.Fixed) {
    return ANALYSIS_CLASS_TYPES.Fixed;
  }
  if (classType === ANALYSIS_CLASS_TYPE_VALUES.Single) {
    return ANALYSIS_CLASS_TYPES.Single;
  }
  return ANALYSIS_CLASS_TYPES.Dynamic;
};

export const SymbolTypes = {
  Diluent: 'diluent',
  Terrain: 'terrain',
};

export const TASK_TYPES = {
  NewSentOrder: 'newSentOrder',
  UpdateOrder: 'updateOrder',
  ImportOfferPdf: 'importOfferPdf',
  ExportReport: 'exportReport',
  SampleReport: 'sampleReport',
  OrderReprintInvoce: 'orderReprintInvoce',
  UnlockedOffer: 'unlockedOffer',
  Import: 'import',
};

export const TASK_STATUSES = {
  Pending: 0,
  Active: 1,
  Failed: 2,
  Completed: 3,
};

export const TASK_STATUSES_DESC = {
  [TASK_STATUSES.Pending]: 'pending',
  [TASK_STATUSES.Active]: 'active',
  [TASK_STATUSES.Failed]: 'failed',
  [TASK_STATUSES.Completed]: 'completed',
};

export const SignatureStatus = {
  Active: 'active',
  Waiting: 'waiting',
  Expired: 'expired',
};

export const FamilyTypes = {
  Default: 'default',
  Challenge: 'challenge',
};

export const SampledBy = {
  Customer: 'customer',
  Complife: 'complife',
};

export const TrackableEntities = {
  LabSample: 'LabSample',
  LabSampleAnalysisOperationValue: 'LabSampleAnalysisOperationValue',
  UserRoles: 'UserRoles',
  RoleConfig: 'RoleConfig',
  OperationRegistry: 'OperationRegistry',
  UserSessionLogin: 'UserSessionLogin',
  AnalysisSpecification: 'AnalysisSpecification',
  Quarantine: 'Quarantine',
  Thermostat: 'Thermostat',
  LabSampleAnalysisStatus: 'LabSampleAnalysisStatus',
  ReportSampleInfo: 'ReportSampleInfo',
  ReportTemperatureLog: 'ReportTemperatureLog',
  SampleReportRevision: 'SampleReportRevision',
};

export const CHANGE_TYPES = {
  update: 'update',
  removal: 'removal',
  addition: 'addition',
};

export const SampleReportType = {
  Default: 'default',
  Challenge: 'challenge',
};

export const UploadedReportRemovalError = {
  NotRemovable: 'SAMPLE_REPORT_UPLOAD_NOT_REMOVABLE',
  AlreadySigned: 'SAMPLE_REPORT_ALREADY_SIGNED',
};
